import * as Cookie from 'js-cookie';

export interface RequestIndexResult {
    isNeedFetch: boolean;
    offset: number;
    count: number;
}

export class SegmentManager {
    static readonly defaultTotal = 10000; // умолчательное количество строк в таблице неизвестного размера
    static readonly defaultSegmentSize =
        Number(Cookie.get('segment_size')) || 200; // умолчательное количество строк в сегменте
    private segments: Record<string, boolean> = {};

    constructor(
        private total: number = SegmentManager.defaultTotal,
        private segmentSize: number = SegmentManager.defaultSegmentSize
    ) {}

    requestIndex(rowIndex: number): RequestIndexResult | null {
        // после фильтрации количество строк может уменьшиться, однако вызовов requestIndex будет столько,
        // сколько было строк в таблице; для "лишних" строк возвращаем null чтобы нарисовались скелетоны;
        // после смены totalCount лишние строки пропадут
        if (rowIndex > this.total) {
            return null;
        }

        const segmentIndex = this.getSegmentIndexByRowIndex(rowIndex);

        if (this.segments[segmentIndex] === true) {
            return {
                isNeedFetch: false,
                offset: 0,
                count: 0
            };
        }

        this.segments[segmentIndex] = true;

        const { segmentSize, total } = this;
        const offset = segmentIndex * segmentSize;
        const count =
            segmentSize + offset > total ? total - offset : segmentSize;

        return {
            isNeedFetch: true,
            offset,
            count
        };
    }

    setTotal(total: number): SegmentManager {
        this.total = total;

        return this;
    }

    reset(): SegmentManager {
        this.segments = {};
        this.total = SegmentManager.defaultTotal;

        return this;
    }

    private getSegmentIndexByRowIndex(index: number): number {
        return Math.floor(index / this.segmentSize);
    }
}
